var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fieldset", [
    _c("label", [_vm._v(_vm._s(_vm.fieldLabel))]),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.hours,
          expression: "hours",
        },
      ],
      attrs: { type: "number", min: "0", placeholder: "00" },
      domProps: { value: _vm.hours },
      on: {
        input: [
          function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.hours = $event.target.value
          },
          _vm.handleInput,
        ],
      },
    }),
    _vm._v(" "),
    _c("span", [_vm._v(":")]),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.minutes,
          expression: "minutes",
        },
      ],
      attrs: { type: "number", min: "0", max: "59", placeholder: "00" },
      domProps: { value: _vm.minutes },
      on: {
        input: [
          function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.minutes = $event.target.value
          },
          _vm.handleInput,
        ],
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }